import { render, staticRenderFns } from "./BulkUpdateUsersModal.vue?vue&type=template&id=58209f13"
import script from "./BulkUpdateUsersModal.vue?vue&type=script&lang=js"
export * from "./BulkUpdateUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports